import { FC } from 'react';

import { useTranslation } from 'react-i18next';

import { makeStyles, Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';

import SearchboxSelector from './SearchboxSelector';

import theme from '../../../../../theme';
import SearchBox from '../../../../SearchBox';
import { DataSelectionType } from '../../../sharedCategoryDrawerUtils';

const useStyles = makeStyles(() => ({
  tagged: {
    '& .MuiAutocomplete-root:last-child': {
      marginTop: '10px'
    }
  },
  dataType: {
    backgroundColor: theme.palette.common.white,
    '& .MuiInputBase-root': {
      height: '44px'
    },
    '& .MuiAutocomplete-endAdornment': {
      marginRight: '15px',
      '& .MuiAutocomplete-popupIndicator': {
        pointerEvents: 'none',
        margin: theme.spacing(0, 0.5),
        transform: 'none',
        color: theme.palette.text.secondary,
        '&.Mui-disabled': {
          color: 'rgba(0, 0, 0, 0.38)'
        }
      }
    }
  },
  fileNameText: {
    color: theme.palette.common.white,
    fontFamily: theme.typography.body2.fontFamily,
    lineHeight: '18px',
    paddingTop: '4px',
    paddingBottom: '8px',
    paddingRight: '21px',
    fontSize: '14px'
  }
}));

interface DataTypeSearchBoxProps {
  dataTypes: DataSelectionType[];
  selectedDataType: DataSelectionType | undefined;
  accounts: any;
  selectedAccountsEntityCount: any;
  adjustmentsByDataType: any;
  onChangeDataType: (event: any, value: DataSelectionType | undefined) => void | Promise<void>;
  onSelectAccountsEntityCount: any;
}

const DataTypeSearchBox: FC<DataTypeSearchBoxProps> = ({
  dataTypes,
  selectedDataType,
  accounts,
  selectedAccountsEntityCount,
  adjustmentsByDataType,
  onChangeDataType,
  onSelectAccountsEntityCount
}: DataTypeSearchBoxProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.tagged}>
      <Typography variant="h3" className={classes.fileNameText}>
        {t('Automatic tagging')}
      </Typography>
      <Box>
        <SearchBox
          options={dataTypes}
          className={classes.dataType}
          placeholder={t('Select Data Type (eg. Tax-Effected Adjustments)')}
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          getOptionLabel={({ name }: any) => `${name}`}
          value={selectedDataType ?? null}
          onChange={onChangeDataType}
        />
      </Box>
      <Box>
        <SearchboxSelector
          isDisabled={!selectedDataType}
          placeholder={t('Select Account Description')}
          options={accounts}
          isLoading={adjustmentsByDataType.isLoading}
          value={selectedAccountsEntityCount}
          onSelect={onSelectAccountsEntityCount}
        />
      </Box>
    </Box>
  );
};

export default DataTypeSearchBox;
